import React from 'react';
import { useHistory } from 'react-router-dom';
import { ActionIcon, Badge, Box, Button, Group, Image, List, Stack, Text, Title } from '@mantine/core';
import AppPaths from '../../AppPaths';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/close.svg';
import SeriesThreePlusHeroPoster from '../../assets/images/series_three_plus_poster.webp';
import UltraFeatureList from './UltraFeatureList';

const CloseButton = () => (
  <ActionIcon
    onClick={() => window.open('fi://closeappview')}
    radius="xl"
    size={38}
    sx={{
      position: 'absolute',
      top: '7.5vh',
      right: '4vw',
      backgroundColor: 'white',
      zIndex: 99999,
      '&:hover': { backgroundColor: 'white' },
      svg: { width: 24, height: 24, fill: 'black' },
    }}
  >
    <CloseIcon />
  </ActionIcon>
);

const BottomCTA = ({ onContinue }: { onContinue: () => void }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      padding: '24px 16px 16px 16px',
      backgroundImage: 'linear-gradient(to top, rgba(0, 0, 0, 1) 85%, rgba(0, 0, 0, 0) 100%)',
      boxShadow: '10px -2px 12px 0px rgba(0, 0, 0, 0.12)',
      zIndex: 1000,
      height: '10em',
    }}
  >
    <Button
      onClick={onContinue}
      radius="lg"
      color="fi-yellow"
      sx={{
        color: 'black',
        width: '90%',
        height: 44,
      }}
    >
      {'Get It Now'}
    </Button>
  </Box>
);

// Keep as image for now until assets are finalized.
const HeroBackground = () => (
  <Box
    sx={{
      paddingTop: '6vh',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'absolute',
    }}
  >
    <Image
      src={SeriesThreePlusHeroPoster}
      alt="hero"
      sx={{
        width: '100%',
        height: 'auto',
        display: 'block',
        pointerEvents: 'none',
      }}
    />
  </Box>
);

export default function UltraUpgradeSelection() {
  const history = useHistory();

  const handleContinue = () => {
    history.push(AppPaths.UltraUpgrade.Complete);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'black',
        overflow: 'scroll',
        zIndex: 1,
        padding: 0,
        margin: 0,
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        color: 'black',
        paddingBottom: 150,
      }}
    >
      <CloseButton />
      <HeroBackground />

      <Stack
        spacing={0}
        sx={{
          position: 'relative',
          zIndex: 1,
          height: '100%',
          maxWidth: 600,
          width: '100%',
          padding: '0 16px',
        }}
      >
        <Group position="center" mt="25vh">
          <Badge
            radius={4}
            color="fi-yellow"
            sx={{
              color: 'black',
              fontWeight: 700,
              fontSize: 14,
              textTransform: 'uppercase',
              padding: '6px 16px 2px',
            }}
          >
            {'NEW'}
          </Badge>
        </Group>

        <Stack spacing={0} align="center">
          <Title
            order={1}
            sx={{
              fontSize: 72,
              fontWeight: 700,
              color: 'white',
              textAlign: 'center',
              margin: '16px 0',
              '@media (max-width: 768px)': {
                fontSize: 56,
              },
            }}
          >
            {'Fi Ultra'}
          </Title>
          <Text size={16} weight={600} color="white" align="center" sx={{ lineHeight: '140%' }}>
            {'Meet the most advanced GPS dog collar ever made'}
          </Text>
        </Stack>
      </Stack>

      <Box
        p={16}
        mx="4em"
        sx={{
          width: 'calc(100% - 4em)',
          maxWidth: 6002,
          position: 'relative',
          zIndex: 1,
          marginTop: '15vh',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: 16,
        }}
      >
        <Stack spacing={0} sx={{ flex: '1 1 0' }}>
          <Group position="apart" align="center" spacing={16}>
            <Image src="/product_images/smart-collar-ultra.png" alt="ultra module" width={56} height={56} />
            <Stack spacing={0} sx={{ flex: 1 }}>
              <Text size="0.9rem" weight={700} color="type-light-primary" transform="uppercase">
                {'LOREM IPSUM DOLOR SIT'}
              </Text>
              <Text size={36} weight={600} sx={{ lineHeight: '120%' }}>
                {'$299'}
              </Text>
            </Stack>
          </Group>
          <List
            size={12}
            mt={12}
            sx={{
              color: 'var(--mantine-color-type-light-secondary)',
              fontWeight: 500,
              lineHeight: '120%',
              '& .mantine-List-itemWrapper': {
                marginBottom: 4,
              },
            }}
          >
            <List.Item>{'Lorem ipsum dolor sit amet consectetur'}</List.Item>
            <List.Item>{'Sed do eiusmod tempor incididunt ut labore'}</List.Item>
            <List.Item>{'Ut enim ad minim veniam quis nostrud'}</List.Item>
          </List>
        </Stack>
      </Box>

      <Box
        mx="1em"
        mt="2em"
        sx={{
          width: 'calc(100% - 2em)',
          maxWidth: 600,
          position: 'relative',
          zIndex: 1,
        }}
      >
        <UltraFeatureList />
      </Box>

      <BottomCTA onContinue={handleContinue} />
    </Box>
  );
}
